export default {
  loadBtn: (state) => {
    return state.loadBtn;
  },

  socialNetworks: (state) => {
    return state.socialNetworks;
  },

  date: (state) => {
    return state.date;
  },

  language: (state) => {
    return state.language;
  },

  changeLanguage: (state) => {
    return state.changeLanguage;
  },

  menuPosition: (state) => {
    return state.menuPosition;
  },

  headerMenu: (state) => {
    return state.headerMenu;
  },

  footerMenu: (state) => {
    return state.footerMenu;
  },

  config: (state) => {
    return state.config;
  },

  aboutUs: (state) => {
    return state.aboutUs;
  },

  contactUs: (state) => {
    return state.contactUs;
  },

  captcha: (state) => {
    return state.captcha;
  },

  categories: (state) => {
    return state.categories;
  },

  blogs: (state) => {
    return state.blogs;
  },
  blog: (state) => {
    return state.blog;
  },

  comments: (state) => {
    return state.comments;
  },
  commentsLength: (state) => {
    return state.commentsLength;
  },

  medias: (state) => {
    return state.medias;
  },
  media: (state) => {
    return state.media;
  },
  mediaGallery: (state) => {
    return state.mediaGallery;
  },

  mediaComments: (state) => {
    return state.mediaComments;
  },
  mediaCommentsLength: (state) => {
    return state.mediaCommentsLength;
  },

  photos: (state) => {
    return state.photos;
  },
  photo: (state) => {
    return state.photo;
  },
  photosGallery: (state) => {
    return state.photosGallery;
  },

  photoComments: (state) => {
    return state.photoComments;
  },
  photoCommentsLength: (state) => {
    return state.photoCommentsLength;
  },



  books: (state) => {
    return state.books;
  },
  bookGallery: (state) => {
    return state.bookGallery;
  },

  bookComments: (state) => {
    return state.bookComments;
  },
  bookCommentsLength: (state) => {
    return state.bookCommentsLength;
  },

  publishers: (state) => {
    return state.publishers;
  },

  authors: (state) => {
    return state.authors;
  },

  sounds: (state) => {
    return state.sounds;
  },
  sound: (state) => {
    return state.sound;
  },
  soundGallery: (state) => {
    return state.soundGallery;
  },

  soundComments: (state) => {
    return state.soundComments;
  },
  soundCommentsLength: (state) => {
    return state.soundCommentsLength;
  },

  bookContents: (state) => {
    return state.bookContents;
  },

  bookDetails: (state) => {
    return state.bookDetails;
  },

  bookPublisher: (state) => {
    return state.bookPublisher;
  },

  search: (state) => {
    return state.search;
  },

  sortOptions() {
    return [
      { text: "پربازدیدترین", value: "3" },
      { text: "جدیدترین", value: "1" },
    ];
  },

};
